import { createConfirmation } from "react-confirm";
import AddNewLocationDialogRecipe from "./AddNewLocationDialogRecipe";

export const showAddNewLocationDialogRecipe = createConfirmation(AddNewLocationDialogRecipe);
